// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCaseRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentCaseRelationshipModel.attributeTypeMap;
    }
}
EnrollmentCaseRelationshipModel.discriminator = undefined;
EnrollmentCaseRelationshipModel.attributeTypeMap = [
    {
        "name": "partyRoleId",
        "baseName": "partyRoleId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    }
];
//# sourceMappingURL=enrollmentCaseRelationshipModel.js.map